import { render } from "./Blocked.vue?vue&type=template&id=1be482c8"
import script from "./Blocked.vue?vue&type=script&lang=js"
export * from "./Blocked.vue?vue&type=script&lang=js"

import exportComponent from "/root/respina-board/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__